import { useEffect, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";

export function useQueryParams(){
    const [queries, setQueries] = useState({})
    const { search } = useLocation();

    const onDecodeParams = useCallback((params) =>{
        const replaceFirst = params.replace("?","");
        const spliceString = replaceFirst.split("&");

        const formatedQuery = {}

        spliceString.forEach((query) => {
            const [key, value] = query.split("=");
            Object.assign(formatedQuery, {
                [key]: value,
            });
        });
        setQueries(formatedQuery);
    }, [])

    useEffect(() => {
        if(search.trim()){
            onDecodeParams(search);
        }
    }, [search, onDecodeParams])
    
    return queries
}